import request from '@/utils/request'

//获取行政区划级联树
export function getXzqTree() {
  return request({
    method: 'get',
    url: "/organization/api/xzqh/tree"
  })
}
//获取行政区划级联树
export function getXzqTreeS(id) {
  return request({
    method: 'get',
    url: "/organization/api/xzqh/tree/"+id
  })
}
//保存单位信息
export function saveQyrzxx(data, type) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/' + type + '/saveQyrzxx',
    data: data
  })
}
//查询单位信息
export function selQyrzxx(type) {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/' + type + '/selQyrzxx'
  })
}
